import Login from './Login';
import Page404 from './Page404';
import Page500 from './Page500';
import ForgotPassword from './Register/ForgotPassword';

export {
  Login, Page404, Page500, ForgotPassword as Register
};


// WEBPACK FOOTER //
// ./src/views/Pages/index.js